import { render } from "./PessoasTabPage.vue?vue&type=template&id=3109f1a8"
import script from "./PessoasTabPage.vue?vue&type=script&lang=js"
export * from "./PessoasTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__